
export default function FlightPath() {
  const steps = [
    {
      number: '01',
      title: 'Capture',
      description: 'AI answers and logs every inbound call or form.',
      icon: 'ri-inbox-line',
      image: 'https://public.readdy.ai/ai/img_res/d3e9f52d86ae26abb2900c4d6776daa1.jpg'
    },
    {
      number: '02',
      title: 'Qualify',
      description: 'Intelligent routing and filtering.',
      icon: 'ri-filter-line',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20minimal%20dark%20navy%20blue%20technology%20concept%20showing%20data%20streams%20being%20filtered%20and%20sorted%20through%20geometric%20layers%20soft%20glowing%20light%20clean%20premium%20aesthetic%20cinematic%20lighting%20futuristic%20dark%20tones%20with%20subtle%20blue%20accents&width=400&height=300&seq=flight-step-2&orientation=landscape'
    },
    {
      number: '03',
      title: 'Book',
      description: 'Automated scheduling integration.',
      icon: 'ri-calendar-check-line',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20minimal%20dark%20navy%20blue%20technology%20concept%20showing%20a%20calendar%20grid%20with%20glowing%20appointment%20slots%20being%20filled%20automatically%20clean%20premium%20aesthetic%20cinematic%20lighting%20futuristic%20dark%20tones%20with%20subtle%20blue%20accents&width=400&height=300&seq=flight-step-3&orientation=landscape'
    },
    {
      number: '04',
      title: 'Convert',
      description: 'Follow-up systems that close the loop.',
      icon: 'ri-check-double-line',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20minimal%20dark%20navy%20blue%20technology%20concept%20showing%20a%20completed%20circuit%20loop%20with%20glowing%20checkmark%20symbol%20clean%20premium%20aesthetic%20cinematic%20lighting%20futuristic%20dark%20tones%20with%20subtle%20blue%20accents&width=400&height=300&seq=flight-step-4&orientation=landscape'
    }
  ];

  return (
    <section id="framework" className="relative bg-[#0B1C2D] py-28 lg:py-36 overflow-hidden">
      {/* Subtle radial glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#2563EB]/5 rounded-full blur-3xl" />

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="text-center mb-20">
          <p className="text-sm font-semibold tracking-[0.2em] uppercase text-[#2563EB] mb-4">Our Process</p>
          <h2 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-white tracking-tight mb-6">
            The Flight Path Framework
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto font-light">
            Structured automation. Controlled execution. Forward momentum.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="group">
              <div className="rounded-2xl overflow-hidden bg-white/5 backdrop-blur-sm border border-white/10 hover:border-[#2563EB]/40 transition-all duration-500 h-full">
                <div className="w-full h-44 overflow-hidden">
                  <img
                    src={step.image}
                    alt={step.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="text-xs font-bold text-[#2563EB] tracking-widest">{step.number}</span>
                    {index < steps.length - 1 && (
                      <div className="hidden lg:flex items-center gap-1 ml-auto">
                        <div className="w-1 h-1 rounded-full bg-[#2563EB]/40" />
                        <div className="w-1 h-1 rounded-full bg-[#2563EB]/60" />
                        <div className="w-1.5 h-1.5 rounded-full bg-[#2563EB]/80" />
                      </div>
                    )}
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">
                    {step.title}
                  </h3>
                  <p className="text-sm text-gray-400 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
